import * as ActionTypes from './actionTypes';

// GET PERFORMANCE STATICS
export const getPerformanceStatics = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_STATICS,
  payload,
});

export const getPerformanceStaticsSuccess = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_STATICS_SUCCESS,
  payload,
});

export const getPerformanceStaticsFailure = () => ({
  type: ActionTypes.GET_PERFORMANCE_STATICS_FAILURE,
});

// GET PERFORMANCE OVERVIEW
export const getPerformanceOverviews = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_OVERVIEWS,
  payload,
});

export const getPerformanceOverviewsSuccess = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_OVERVIEWS_SUCCESS,
  payload,
});

export const getPerformanceOverviewsFailure = () => ({
  type: ActionTypes.GET_PERFORMANCE_OVERVIEWS_FAILED,
});

// GET PERFORMANCE CHARTS
export const getPerformanceCharts = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_CHARTS,
  payload,
});

export const getPerformanceChartsSuccess = (payload) => ({
  type: ActionTypes.GET_PERFORMANCE_CHARTS_SUCCESS,
  payload,
});

export const getPerformanceChartsFailure = () => ({
  type: ActionTypes.GET_PERFORMANCE_CHARTS_FAILED,
});

// GET INSIGHT OVERVIEW
export const getInsightOverview = (payload) => ({
  type: ActionTypes.GET_INSIGHT_OVERVIEW,
  payload,
});

export const getInsightOverviewSuccess = (payload) => ({
  type: ActionTypes.GET_INSIGHT_OVERVIEW_SUCCESS,
  payload,
});

export const getInsightOverviewFailed = () => ({
  type: ActionTypes.GET_INSIGHT_OVERVIEW_FAILED,
});

// GET REVENUE DISTRIBUTION OVERVIEW
export const getRevenueDistributionOverview = (payload) => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW,
  payload,
});

export const getRevenueDistributionOverviewSuccess = (payload) => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW_SUCCESS,
  payload,
});

export const getRevenueDistributionOverviewFailed = () => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW_FAILED,
});

// GET REVENUE DISTRIBUTION CHART
export const getRevenueDistributionChart = (payload) => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_CHART,
  payload,
});

export const getRevenueDistributionChartSuccess = (payload) => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_CHART_SUCCESS,
  payload,
});

export const getRevenueDistributionChartFailed = () => ({
  type: ActionTypes.GET_REVENUE_DISTRIBUTION_CHART_FAILED,
});
